import React from "react";

import { getPfizerSonnexusFreeDrugFormInitialValues } from "./form/initialValues";
import { SaveButton } from "../../header";
import useBaseEEConfiguration from "../../hooks/useBaseEEConfiguration";
import { applyTrimFields } from "../../utils/updateFormData";
import renderReactFromJson from "../../utils/renderReactFromJson";
import formJson from "./form/PfizerFreeDrugSonnexusFormJson.json";
import { CompleteFormButton } from "../../CompleteFormButton";
import { SignerTypes, SIGNATURE_OPTIONS, RequiredSignerTypes } from "../../../../../constant/ESign";
import { HEADER_SUBMIT_BUTTON_TYPES } from "../../constants";
import { fileTypes, MB } from "../../../../Uploader";
import moment from "moment";
import { DATE_FORMAT } from "../../../../../utils/date";
import { Trans } from "react-i18next";

export const usePfizerFreeDrugSonnexusConfiguration = () => {
  const vendorName = "pfizerSonnexus";
  const eePlanType = "free_drug";
  const rootPath = "application_form_editor.pfizer_sonnexus.free_drug"; //EE TODO: add data to src/locales/translations/en/ApplicationFormEditor.js

  const baseConfig = useBaseEEConfiguration({ vendorName, eePlanType, rootPath, formJson });

  const pfizerSonnexusSpecificConfig = {
    activeFormSection: "",
    shouldLoadTreatments: true,
    shouldLoadPatientDiagnosis: true,
    shouldFillContactFullName: true,
    getFormInitialValues: ({ applicationForm, treatments, diagnosis, contactFullName }) =>
      getPfizerSonnexusFreeDrugFormInitialValues({ applicationForm, formJson, treatments, diagnosis, contactFullName }),
    getFormFromJson: (form) => renderReactFromJson(form, formJson),
    saveButton: (props) => (
      <SaveButton onSave={(form) => applyTrimFields(form)} id={"EE_pfizer_sonnexus_free_drug_save_form"} {...props} />
    ),
    afterSubmissionPayload: () => ({}),
    applicationFormHeaderSubmission: (props) => <CompleteFormButton id={"EE_complete_button"} {...props} />,
    headerSubmitButtonType: HEADER_SUBMIT_BUTTON_TYPES.COMPLETE_FORM,
    attachmentsSectionFileTypesAccepted: fileTypes.PDF,
    attachmentsSectionMaxFileSize: 6 * MB,
    shouldShowFileSize: true,
    shouldShowPdfInSecondStep: true,
    getSignatureWidgetSettingsBySignerType: (signerType) => {
      const signatureSettings = {
        [SignerTypes.PATIENT_OR_CAREGIVER]: {
          editable: true,
          titleTranslationKey: "patientApplications.enroll.electronic_signatures.signature_step.signers.patient",
          shouldShowCaregiverIndication: false,
          shouldUseRemoteRequestCheckboxes: false
        },
        [SignerTypes.PHYSICIAN]: {
          editable: true,
          titleTranslationKey: "patientApplications.enroll.electronic_signatures.signature_step.signers.physician",
          shouldShowCaregiverIndication: false,
          shouldUseRemoteRequestCheckboxes: false
        }
      };
      return signatureSettings[signerType];
    },

    signatureOptionsConfig: {
      [RequiredSignerTypes.PATIENT_OR_CAREGIVER]: [SIGNATURE_OPTIONS.SIGNATURE_REQUEST],
      [RequiredSignerTypes.PHYSICIAN]: [SIGNATURE_OPTIONS.SIGNATURE_REQUEST, SIGNATURE_OPTIONS.FILL_NOW]
    }
  };

  return {
    ...baseConfig,
    ...pfizerSonnexusSpecificConfig,
    submissionStep: {
      description: (t) => t("patientApplications.enroll.application_form_submission.eSign.description"),
      getSubmitButtonText: (t) => t("patientApplications.enroll.application_form_submission.submit_button"),
      submitModal: {
        showNotice: true,
        attachments: {
          showAllowedFileTypesNotice: true
        }
      },
      getSubmitSuccessMessage: (t) => t("patientApplications.enroll.application_form_submission.submit_success_message")
    },
    successMessage: (t, submittedDate, shouldAutoSubmit) =>
      t(
        !shouldAutoSubmit
          ? "patientApplications.enroll.application_form_submission.submit_completed"
          : "patientApplications.enroll.application_form_submission.auto_submit_succeeded",
        {
          submitDate: moment(submittedDate).format(DATE_FORMAT)
        }
      ),
    inProgressMessage: (t, submittedDate) => (
      <Trans
        i18nKey="patientApplications.enroll.application_form_submission.eagle_pemfexy.submit_in_progress"
        components={{
          bold: <strong />
        }}
        values={{ submitDate: moment(submittedDate).format(DATE_FORMAT) }}
      />
    )
  };
};

export default usePfizerFreeDrugSonnexusConfiguration;
